var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_257_17559",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1H1V15H15V1Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41797 6.19532C4.11593 6.19532 3.87109 6.44015 3.87109 6.74219C3.87109 7.04423 4.11593 7.28906 4.41797 7.28906C4.72001 7.28906 4.96484 7.04423 4.96484 6.74219C4.96484 6.44015 4.72001 6.19532 4.41797 6.19532Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79687 6.19532C6.49484 6.19532 6.25 6.44015 6.25 6.74219C6.25 7.04423 6.49484 7.28906 6.79687 7.28906C7.09891 7.28906 7.34375 7.04423 7.34375 6.74219C7.34375 6.44015 7.09891 6.19532 6.79687 6.19532Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17578 6.19532C8.87374 6.19532 8.62891 6.44015 8.62891 6.74219C8.62891 7.04423 8.87374 7.28906 9.17578 7.28906C9.47782 7.28906 9.72265 7.04423 9.72265 6.74219C9.72265 6.44015 9.47782 6.19532 9.17578 6.19532Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5547 6.19532C11.2526 6.19532 11.0078 6.44015 11.0078 6.74219C11.0078 7.04423 11.2526 7.28906 11.5547 7.28906C11.8567 7.28906 12.1016 7.04423 12.1016 6.74219C12.1016 6.44015 11.8567 6.19532 11.5547 6.19532Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96484 9.1211C4.96484 8.81906 4.72001 8.57422 4.41797 8.57422C4.11593 8.57422 3.87109 8.81906 3.87109 9.1211C3.87109 9.42313 4.11593 9.66797 4.41797 9.66797C4.72001 9.66797 4.96484 9.42313 4.96484 9.1211Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96484 11.5C4.96484 11.198 4.72001 10.9531 4.41797 10.9531C4.11593 10.9531 3.87109 11.198 3.87109 11.5C3.87109 11.802 4.11593 12.0469 4.41797 12.0469C4.72001 12.0469 4.96484 11.802 4.96484 11.5Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34375 9.1211C7.34375 8.81906 7.09891 8.57422 6.79687 8.57422C6.49484 8.57422 6.25 8.81906 6.25 9.1211C6.25 9.42313 6.49484 9.66797 6.79687 9.66797C7.09891 9.66797 7.34375 9.42313 7.34375 9.1211Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34375 11.5C7.34375 11.198 7.09891 10.9531 6.79687 10.9531C6.49484 10.9531 6.25 11.198 6.25 11.5C6.25 11.802 6.49484 12.0469 6.79687 12.0469C7.09891 12.0469 7.34375 11.802 7.34375 11.5Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79687 6.19532C6.49484 6.19532 6.25 6.44015 6.25 6.74219C6.25 7.04423 6.49484 7.28906 6.79687 7.28906C7.09891 7.28906 7.34375 7.04423 7.34375 6.74219C7.34375 6.44015 7.09891 6.19532 6.79687 6.19532Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34375 9.1211C7.34375 8.81906 7.09891 8.57422 6.79687 8.57422C6.49484 8.57422 6.25 8.81906 6.25 9.1211C6.25 9.42313 6.49484 9.66797 6.79687 9.66797C7.09891 9.66797 7.34375 9.42313 7.34375 9.1211Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34375 11.5C7.34375 11.198 7.09891 10.9531 6.79687 10.9531C6.49484 10.9531 6.25 11.198 6.25 11.5C6.25 11.802 6.49484 12.0469 6.79687 12.0469C7.09891 12.0469 7.34375 11.802 7.34375 11.5Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72265 9.1211C9.72265 8.81906 9.47782 8.57422 9.17578 8.57422C8.87374 8.57422 8.62891 8.81906 8.62891 9.1211C8.62891 9.42313 8.87374 9.66797 9.17578 9.66797C9.47782 9.66797 9.72265 9.42313 9.72265 9.1211Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1016 9.1211C12.1016 8.81906 11.8567 8.57422 11.5547 8.57422C11.2526 8.57422 11.0078 8.81906 11.0078 9.1211C11.0078 9.42313 11.2526 9.66797 11.5547 9.66797C11.8567 9.66797 12.1016 9.42313 12.1016 9.1211Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_257_17559)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_257_17559",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 14.4V1.6H1.6V14.4H14.4Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_257_17559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.78123 14.4531H3.1875C2.28141 14.4531 1.54688 13.7186 1.54688 12.8125V4.28128C1.54688 3.37519 2.28141 2.64066 3.1875 2.64066H12.8125C13.7186 2.64066 14.4531 3.37519 14.4531 4.28128V8.16408",
    stroke: "#355C9D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.41797 6.19532C4.11593 6.19532 3.87109 6.44015 3.87109 6.74219C3.87109 7.04423 4.11593 7.28906 4.41797 7.28906C4.72001 7.28906 4.96484 7.04423 4.96484 6.74219C4.96484 6.44015 4.72001 6.19532 4.41797 6.19532Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79687 6.79532C6.82621 6.79532 6.85 6.77152 6.85 6.74219C6.85 6.71286 6.82621 6.68906 6.79687 6.68906C6.76754 6.68906 6.74375 6.71286 6.74375 6.74219C6.74375 6.77152 6.76754 6.79532 6.79687 6.79532Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17575 6.19532C8.87371 6.19532 8.62888 6.44015 8.62888 6.74219C8.62888 7.04423 8.87371 7.28906 9.17575 7.28906C9.47779 7.28906 9.72262 7.04423 9.72262 6.74219C9.72262 6.44015 9.47779 6.19532 9.17575 6.19532Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5547 6.19532C11.2526 6.19532 11.0078 6.44015 11.0078 6.74219C11.0078 7.04423 11.2526 7.28906 11.5547 7.28906C11.8567 7.28906 12.1015 7.04423 12.1015 6.74219C12.1015 6.44015 11.8567 6.19532 11.5547 6.19532Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96484 9.1211C4.96484 8.81906 4.72001 8.57422 4.41797 8.57422C4.11593 8.57422 3.87109 8.81906 3.87109 9.1211C3.87109 9.42313 4.11593 9.66797 4.41797 9.66797C4.72001 9.66797 4.96484 9.42313 4.96484 9.1211Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96484 11.5C4.96484 11.198 4.72001 10.9531 4.41797 10.9531C4.11593 10.9531 3.87109 11.198 3.87109 11.5C3.87109 11.802 4.11593 12.0469 4.41797 12.0469C4.72001 12.0469 4.96484 11.802 4.96484 11.5Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74375 9.1211C6.74375 9.15043 6.76754 9.17422 6.79687 9.17422C6.82621 9.17422 6.85 9.15043 6.85 9.1211C6.85 9.09176 6.82621 9.06797 6.79687 9.06797C6.76754 9.06797 6.74375 9.09176 6.74375 9.1211Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74375 11.5C6.74375 11.5293 6.76754 11.5531 6.79687 11.5531C6.82621 11.5531 6.85 11.5293 6.85 11.5C6.85 11.4707 6.82621 11.4469 6.79687 11.4469C6.76754 11.4469 6.74375 11.4707 6.74375 11.5Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79687 6.19532C6.49484 6.19532 6.25 6.44015 6.25 6.74219C6.25 7.04423 6.49484 7.28906 6.79687 7.28906C7.09891 7.28906 7.34375 7.04423 7.34375 6.74219C7.34375 6.44015 7.09891 6.19532 6.79687 6.19532Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34375 9.1211C7.34375 8.81906 7.09891 8.57422 6.79687 8.57422C6.49484 8.57422 6.25 8.81906 6.25 9.1211C6.25 9.42313 6.49484 9.66797 6.79687 9.66797C7.09891 9.66797 7.34375 9.42313 7.34375 9.1211Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34375 11.5C7.34375 11.198 7.09891 10.9531 6.79687 10.9531C6.49484 10.9531 6.25 11.198 6.25 11.5C6.25 11.802 6.49484 12.0469 6.79687 12.0469C7.09891 12.0469 7.34375 11.802 7.34375 11.5Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.41797 1.54688V3.73438",
    stroke: "#355C9D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5547 3.73438V1.54688",
    stroke: "#355C9D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72262 9.1211C9.72262 8.81906 9.47779 8.57422 9.17575 8.57422C8.87371 8.57422 8.62888 8.81906 8.62888 9.1211C8.62888 9.42313 8.87371 9.66797 9.17575 9.66797C9.47779 9.66797 9.72262 9.42313 9.72262 9.1211Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1015 9.1211C12.1015 8.81906 11.8567 8.57422 11.5547 8.57422C11.2526 8.57422 11.0078 8.81906 11.0078 9.1211C11.0078 9.42313 11.2526 9.66797 11.5547 9.66797C11.8567 9.66797 12.1015 9.42313 12.1015 9.1211Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97263 1.54688V3.73438",
    stroke: "#355C9D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.73932 12.5132L10.4844 14.2162C10.8487 14.563 11.4315 14.5241 11.7465 14.1321L14.4531 10.3516",
    stroke: "#355C9D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.84934b4d37df5a9783ebd57c2ff0c629.svg";
export { ForwardRef as ReactComponent };